import ForbiddenError from '../errors/ForbiddenError';
/**
 * Redirect on 403 error
 *
 * @param  {Error} error - caught exception
 * @return {Error} - thrown error
 */

export default function redirectOnForbidden(error) {
  if (process.env.IS_BROWSER && error instanceof ForbiddenError) window.location = '/account/refused';
  throw error;
}